<template>
  <div class="page landing">
    <section class="content">
      <form ref="form" class="form">
        <div ref="mobileRef" class="form-item">
          <nd-input
            name="mobile"
            v-model="form.mobile"
            placeholder="请输入手机号"
            type="pure-number"
            maxLength="11"
            @blur="mobileBlur"
            @focus="mobileFocus"
          />
        </div>
        <div ref="codeRef" class="form-item">
          <nd-input
            name="smsCode"
            v-model="form.smsCode"
            placeholder="请输入验证码"
            type="pure-number"
            maxLength="6"
            @blur="codeBlur"
            @focus="codeFocus"
          />
          <nd-send-code
            class="send-code"
            :disabled="smsDisabled"
            :sendCode="sendCodeHandler"
          />
        </div>
        <div ref="agreeRef" class="agree">
          <van-checkbox v-model="agreeChecked" checked-color="#FF4633">
            我已阅读并同意
            <span class="highlight" @click.stop="protocolPopup = true">《用户服务协议》</span>
          </van-checkbox>
        </div>
        <div class="btn-name">
          <div class="btn" @click="goLoan">
            <span>查看我的额度</span>
            <img src="https://static.ndmicro.com/tmd/landing/h5-credit/images/icon_arrow_right.png">
            <img class="light" src="https://static.ndmicro.com/tmd/landing/h5-credit/images/img_light.png">
          </div>
          <img class="srate" src="https://static.ndmicro.com/tmd/landing/h5-credit/images/img_tongguol@2x.png" alt="">
        </div>
      </form>
    </section>
    <van-popup
      v-model="protocolPopup"
      class="protocol-popup"
      position="bottom"
    >
      <dl>
        <dt>
          用户服务协议
          <img
            src="https://static.ndmicro.com/tmd/landing/h5-credit/images/btn_close.png"
            srcset="
              https://static.ndmicro.com/tmd/landing/h5-credit/images/btn_close@2x.png 2x,
              https://static.ndmicro.com/tmd/landing/h5-credit/images/btn_close@3x.png 3x
            "
            @click="protocolPopup = false"
          />
        </dt>
        <dd tag="dd" v-for="(item, index) in protocols" :key="index" @click="routerToProtocol(item.path)">
          {{item.name}}
        </dd>
      </dl>
    </van-popup>
  </div>
</template>

<script>
import { judgeClientSystem } from '@/assets/utils'
import { Swipe, SwipeItem, Popup, Checkbox } from 'vant'
import { mapActions, mapState } from 'vuex'
import validate from '../../../components/nd-validate'
import axios from '@/assets/axios'
import isIntercept from '@/assets/intercept-mixin'
import { getKey } from '../../../assets/utils'
import configMixins from '../configMixins'
export default {
  name: 'landingGeneral',

  mixins: [validate, configMixins],

  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    Popup,
    VanCheckbox: Checkbox
  },
  data () {
    return {
      creditLiving: '',
      isIos: judgeClientSystem() === 'IOS',
      rules: {
        mobile: [
          {
            require: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            regular: /^1[0-9]{10}$/,
            message: '手机号码格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
        smsCode: [
          {
            require: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
          {
            regular: /[0-9]{6}$/,
            message: '验证码错误，请重新输入',
            trigger: 'blur'
          }
        ]
      },
      form: {
        mobile: '',
        smsCode: '',
        smsKey: ''
      },
      agreeChecked: false,
      protocolPopup: false,
      protocols: [{ name: '《天美贷用户注册及服务协议》', path: '/tmd/protocol/login' }, { name: '《天美贷隐私政策》', path: '/tmd/protocol/privacy' }],
      channel: ''
    }
  },
  computed: {
    smsDisabled () {
      const disabled = !this.validateWithoutTip({ mobile: this.rules.mobile })
      if (!disabled) {
        this.$sensors.track('general_event', {
          additinal_status: 'mobile_complete'
        })
      }
      return disabled
    },
    ...mapState('user', {
      authStatus: (state) => state.userInfo.authStatus || []
    })
  },
  watch: {
    'form.smsCode' (val) {
      if (val && val.length === 6) {
        this.$sensors.track('general_event', {
          additinal_status: 'code_complete'
        })
      }
    }
  },
  async created () {
    if (this.$route.query?.result === 'PASS') {
      this.checkFaceResult()
    } else {
      this.$bus.$emit('ready')
    }
    // 获取落地页渠道
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)
  },
  methods: {
    ...mapActions('user', ['sendCodeX', 'loginBySmsX', 'getUserInfoX', 'getIRR24', 'getChannelJumpX', 'getLimitX']),
    ...mapActions('user', ['getUserInfoX']),
    ...mapActions('authentication', ['onlyPreApply']),
    async checkFaceResult () {
      const { success } = await this.onlyPreApply({
        creditFLowType: 'H5_CREDIT'
      })
      if (success) {
        this.$router.replace('/authentication/base-h5-credit')
      }
    },
    
    // 点击获取验证码
    sendCodeHandler () {
      this.$report({
        id: 50018,
        args: {
          target: 'GENERAL8'
        }
      })
      this.$sensors.track('general_event', {
        'submissions': { mobile: this.form.mobile }
      })
      return new Promise((resolve, reject) => {
        this.sendCodeX({
          mobile: this.form.mobile
        }).then(response => {
          if (response.success) {
            this.form.smsKey = response.data.smsKey
            resolve(true)
          } else {
            reject(new Error(response.msg))
          }
        })
      })
    },
    // 立即借款
    async goLoan () {
      const res = this.validateWithoutTip(this.rules, (msg) => {
        if (['请输入手机号', '手机号码格式错误，请重新输入'].includes(msg)) {
          this.$refs['mobileRef'].classList.add('shake')
          setTimeout(() => {
            this.$refs['mobileRef'].classList.remove('shake')
          }, 600)
        }
        if (['请输入验证码', '验证码错误，请重新输入'].includes(msg)) {
          this.$refs['codeRef'].classList.add('shake')
          setTimeout(() => {
            this.$refs['codeRef'].classList.remove('shake')
          }, 600)
        }
        this.$message(msg)
      })
      if (!res) return
      if (!this.agreeChecked) {
        this.$refs['agreeRef'].classList.add('shake')
        setTimeout(() => {
          this.$refs['agreeRef'].classList.remove('shake')
        }, 600)
        return this.$message('请先勾选并同意用户服务协议')
      }
      if (this.$route.query) {
        this.form.extParam = this.$route.query
      }
      this.$sensors.track('general_event', {
        'submissions': { mobile: this.form.mobile, smsCode: this.form.smsCode }
      })
      const response = await this.loginBySmsX(this.form)
      if (response.success) {
        this.$statistics('LOGIN')
        await this.getUserInfoX({ forceUpdate: true, checkToken: true })
        await this.getProcessType()
        this.nextStep()
      } else {
        if (response.code === '000010') {
          this.$message(response.msg)
        }
      }
    },

    /**
     * 补充资料
     */
    toFill () {
      let { authStatus } = getKey('userInfo') || {}
      authStatus = authStatus || []
      if (!authStatus.includes('OCR')) {
        this.$router.push('/authentication/id-h5-credit')
      } else if (authStatus.includes('OCR_EXPIRE')) {
        this.$router.replace('/authentication/supplementaryOCR?status=expired')
      } else if (this.creditLiving === 'PRE_CREDIT_LIVING') {
        this.$router.replace('/authentication/face?redirectUrl=/authentication/base-h5-credit')
      } else {
        this.$router.push('/authentication/base-h5-credit')
      }
    },
  
    async nextStep () {
      const userInfo = getKey('userInfo') || {}
      const registerChannel = userInfo.registerChannel
      
      if (registerChannel !== this.channel) {
        this.$message('您已成功注册天美贷')
        return
      }
      const limitRes = await this.getLimitX({ loanPlatform: 'TMD' })
      if (limitRes.success) {
        const {
          creditStatus,
          creditLiving
        } = limitRes.data
        this.creditLiving = creditLiving
        switch (creditStatus) {
          case 'UNCREDIT':
          case 'PRE_SUCCESS':
          case 'CREDIT_EXPIRE':
            this.toFill() // 补充资料
            break
          case 'CREDIT_REFUSED':
            this.$message('您已成功注册天美贷')
            break
          case 'CREDIT':
          case 'CREDIT_LOCKED':
          case 'CREDIT_REVIEW':
          case 'CREDIT_ERROR':
          case 'CREDIT_SUCCESS':
          case 'LOAN_INFO':
          case 'LOAN_REFUSED':
            this.$router.replace('/landing/h5-credit-result')
            break
          default:
            break
        }
      }
    },

    async getProcessType () {
      const res = await axios.post('/order/v1/biz-route', {
        channelNo: this.channel
      })
      if (res.data.success) {
        this.nextNode = res.data.data.currentNode
        this.loanList = res.data.data.loanList
        this.serialNo = res.data.data.serialNo
        this.half = res.data.data.half
      }
    },
    mobileBlur () {
      this.$report({
        id: 50016,
        args: {
          content: this.form.mobile,
          target: 'GENERAL8'
        }
      })
    },
    codeBlur () {
      this.$report({
        id: 50017,
        args: {
          content: this.form.smsCode,
          target: 'GENERAL8'
        }
      })
    },
    mobileFocus () {
      this.$sensors.track('general_event', {
        additinal_status: 'mobile_focus'
      })
    },
    codeFocus () {
      this.$sensors.track('general_event', {
        additinal_status: 'code_focus'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes shake {
  20% {
    -webkit-transform: rotate(2.5deg);
    transform: rotate(2.5deg)
  }
  40% {
    -webkit-transform: rotate(-2.5deg);
    transform: rotate(-2.5deg)
  }
  60% {
    -webkit-transform: rotate(2.5deg);
    transform: rotate(2.5deg)
  }
  80% {
    -webkit-transform: rotate(-2.5deg);
    transform: rotate(-2.5deg)
  }
  to {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }
}
@keyframes light-scroll {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(300%);
  }
}
.landing {
  height: 1705px;
  background-image: url(https://static.ndmicro.com/tmd/landing/h5-credit/images/bg.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  padding-top: 660px;
  .content {
    width: 100%;
    border-radius: 8px;
    margin: 0 auto;
    padding: 0 60px;
    .form {
      width: 100%;
      .form-item {
        margin: 0 auto;
        width: 100%;
        height: 90px;
        line-height: 90px;
        background-color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        padding: 0 15px 0 30px;
        margin-top: 40px;
        font-size: 33px;
        font-family: PingFang SC;
        font-weight: 400;
        &.shake {
          animation: shake .3s linear;
        }

        .nd-input {
          input {
            font-size: 33px;
            height: 50px;
            line-height: 50px;
          }
        }

        .form-tip.visible {
          color: transparent;
          opacity: 0;
        }

        .send-code {
          height: 61px;
          line-height: 61px;
          width: 183px;
          border: 1px solid #ff4633;
          color: #ff4633;
          background-color: white;
          border-radius: 31px;
          font-size: 27px;
          flex-shrink: 0;

          span {
            font-size: 27px;
          }

          &.disabled {
            color: @fc4;
            border: 1px solid @fc4;
          }
        }
      }

      .agree {
        display: inline-block;
        margin-top: 40px;
        height: 30px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
        &.shake {
          animation: shake 1s linear
        }
        .highlight {
          color: #994C27;
        }
        /deep/.van-checkbox__icon{
          font-size: 28px;
          .van-icon{
            border-color: #999999;
            border-width: 2px;
            &::before{
              color: #FFFFFF;
            }
          }
        }
        /deep/.van-checkbox__label{
          color: #999999;
        }
      }
      .btn-name {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        position: relative;
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          position: relative;
          img {
            width: 11px;
            height: 18px;
            margin-left: 14px;
          }
          .light {
            position: absolute;
            left: 0;
            animation: light-scroll 1.8s linear infinite;
            width: 204px;
            height: 99px;
          }
        }
        .srate {
          position: absolute;
          right: 20px;
          top:-2px;
          width:181px;
          height:41px;
          pointer-events: none;
        }
      }
      .btn {
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        width: 570px;
        height: 94px;
        line-height: 94px;
        border-radius: 47px;
        text-align: center;
      }
    }
  }

  .protocol-popup {
    background-color: transparent;
    dl {
      background-color: #fff;
      border-radius: 30px 30px 0px 0px;
      padding-bottom: 80px;
      dt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 50px;
        height: 170px;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        > img {
          width: 33px;
          height: 33px;
        }
      }
      dd {
        height: 110px;
        padding: 0 40px;
        line-height: 110px;
        font-size:30px;
        border-top: 1px solid #EEEEEE;
      }
    }
  }
}
</style>